var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hasError
    ? _c(
        "ul",
        {
          staticClass: "grid sm:grid-cols-2 gap-3",
          attrs: { "data-testid": "interior-results" },
        },
        [
          _vm.isNewJob
            ? _c(
                "li",
                {
                  staticClass:
                    "flex justify-between sm:flex-col bg-white px-3 py-4",
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "sm:text-md flex items-center leading-tight",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "link underline",
                          attrs: {
                            href: "/supplementary/undercoat-pigmented-sealer",
                            target: "_blank",
                          },
                        },
                        [_vm._v("Primer")]
                      ),
                      _vm._v(" "),
                      _c("ButtonInfo", {
                        staticClass: "ml-2",
                        attrs: {
                          heading: "",
                          body: "Our undercoat/pigmented sealer is the the perfect all-round primer – suited for most interior spaces and timbers",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "sm:text-md font-semibold" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm._f("formatVolume")(_vm.quantities.primer)) +
                        "\n    "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass:
                "flex justify-between sm:flex-col bg-white px-3 py-4",
            },
            [
              _c(
                "h4",
                { staticClass: "sm:text-md flex items-center leading-tight" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "link underline",
                      attrs: { href: "/paint/wall-paint", target: "_blank" },
                    },
                    [_vm._v("Wall Paint")]
                  ),
                  _vm._v(" "),
                  _c("ButtonInfo", {
                    staticClass: "ml-2",
                    attrs: {
                      heading: "",
                      body: "A durable & washable interior wall paint",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sm:text-md font-semibold" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("formatVolume")(_vm.quantities.wallPaint)) +
                    "\n    "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass:
                "flex justify-between sm:flex-col bg-white px-3 py-4",
            },
            [
              _c(
                "h4",
                { staticClass: "sm:text-md flex items-center leading-tight" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "link underline",
                      attrs: { href: "/paint/ceiling-paint", target: "_blank" },
                    },
                    [_vm._v("Ceiling Paint")]
                  ),
                  _vm._v(" "),
                  _c("ButtonInfo", {
                    staticClass: "ml-2",
                    attrs: {
                      heading: "",
                      body: "A high coverage matt finish perfect for ceilings",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sm:text-md font-semibold" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm._f("formatVolume")(_vm.quantities.ceilingPaint)
                    ) +
                    "\n    "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass:
                "flex justify-between sm:flex-col bg-white px-3 py-4",
            },
            [
              _c(
                "h4",
                { staticClass: "sm:text-md flex items-center leading-tight" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "link underline",
                      attrs: { href: "/paint/enamel-paint", target: "_blank" },
                    },
                    [_vm._v("Enamel Paint")]
                  ),
                  _vm._v(" "),
                  _c("ButtonInfo", {
                    staticClass: "ml-2",
                    attrs: {
                      heading: "",
                      body: "Hard wearing & washable finish for doors, windows, cabinetry and bathrooms",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sm:text-md font-semibold" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("formatVolume")(_vm.quantities.enamelPaint)) +
                    "\n    "
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }